import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import propTypes from 'prop-types';
import Navbar from './Navbar/Navbar';

function WithNavbar(props) {
  return (
    <div className="App">
      <CssBaseline />
      <Navbar />
      {props.children}
    </div>
  );
}

const Props = {
  children: propTypes.element,
};

WithNavbar.propTypes = Props;

export default WithNavbar;
